export default () => {
  sessionStorage.clear();
  if (sessionStorage.getItem("@LockytEnterprise:token")) {
    return false;
  }
  return true;
};
